import React from 'react';
import PhilliesTeamStoreSvg, { FLOOR_BOUNDS, SVG_DIMENSIONS } from "./PhilliesTeamStoreSvg.js";
import StoreMapCanvas from "../../../../pages/Retail/map/StoreMapCanvas.js";

/**
 * PHILLIES TEAM STORE MAP COMPONENT
 * 
 * Renders zones into a single combined SVG where both floors share
 * the same coordinate system. Zone coordinates from locations.json
 * are absolute SVG coordinates - no transform offset needed.
 */

// Analytics view layout config - exported for RetailMap to use
export const ANALYTICS_CONFIG = {
  mapColClass: "col-md-8",
  listColClass: "col-md-4",
  mapMaxWidth: "1000px",
  mapWidth: "85%"
};

// Floor label positions (drawing units)
const FLOOR_LABEL_COORDS = {
  1: { x: 420, y: 670 },
  2: { x: 960, y: 560 }
};

const PhilliesTeamStoreMap = (props) => {
  const floors = props.currentLocation?.floors || [];
  const floorLabel = (floorId) => floors.find((f) => f.id === floorId)?.label;

  return (
    <StoreMapCanvas
      {...props}
      Background={PhilliesTeamStoreSvg}
      width={SVG_DIMENSIONS.width}
      height={SVG_DIMENSIONS.height}
      labelSize={24}
      maxHeight={500}
      extraSvg={floors.map((floor) => {
        const bounds = FLOOR_BOUNDS[floor.id];
        const coords = FLOOR_LABEL_COORDS[floor.id] || { x: bounds.x + bounds.width / 2, y: bounds.height - 20 };
        return (
          <text
            key={`floor-label-${floor.id}`}
            x={coords.x}
            y={coords.y}
            textAnchor="middle"
            style={{ fontSize: '24px', fontWeight: 'bold', fill: '#333', pointerEvents: 'none' }}
          >
            {floor.label}
          </text>
        );
      })}
      tooltipExtra={(zone) => (floorLabel(zone.floor)
        ? <div className="rx-store-map-tip-floor">{floorLabel(zone.floor)}</div>
        : null)}
    />
  );
};

export default PhilliesTeamStoreMap;
